import React, { ChangeEvent, memo, useCallback } from 'react';
import { Select as SelectBase } from "@chakra-ui/core";

import { Container, Label } from './styles';

interface IProps {
  onChange: (params: { page: number }, remove?: string[]) => void;
  field: string;
  label: string;
  options?: { value: string; label: string }[];
  placeholder?: string;
  width?: string;
  minWidth?: string;
  dependent?: string[];
}

const SearchSelect = memo((props: IProps) => {
  const { onChange, field, label, options, width, dependent, ...extra } = props;

  const handleChange = useCallback((event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    onChange({ page: 0, [field]: value }, dependent);
  }, [onChange, field, dependent]);

  return (
    <Container style={{ width: width }}>
      <Label>{label}</Label>
      <SelectBase {...extra} onChange={handleChange} borderRadius="6px" borderColor="#01509C" height="36px" fontSize={14}>
        <option value=""></option>
        {options?.map(o =>
          <option key={o.value} value={o.value}>{o.label}</option>
        )}
      </SelectBase>
    </Container>
  );
});

export default SearchSelect;
